import WeaMoreButton from "../wea-more-button";
import "./index.less";
import middleware from "../../middleware";
class Main extends React.Component {
  static defaultProps = {
    borderTop: true
  };
  constructor(props) {
    super(props);
  }
  render() {
    let {
      buttons = [],
      moreBtn,
      borderTop,
      className = "",
      style
    } = this.props;
    if (moreBtn && Object.keys(moreBtn).length > 0) {
      buttons = buttons.concat([<WeaMoreButton {...moreBtn} />]);
    }
    return (
      <div
        className={`wea-dialog-footer ${borderTop ? "bTop" : ""} ${className}`}
        style={style}
      >
        {buttons}
      </div>
    );
  }
}

const Com = middleware(Main, "WeaDialogFooter");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-dialog-footer/index.js